(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5029],{

/***/ 96604:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-landing",
      function () {
        return __webpack_require__(91963);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83554);
/* harmony import */ var _contexts_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48309);




var TitlePartial = function(param) {
    var name = param.name, className = param.className, cs = param.cs;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_3__/* .useMasterData */ .AE)();
    var theme = (masterData !== null && masterData !== void 0 ? masterData : {}).theme;
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "_title tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-justify-center  tw-w-full  tw-relative ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-w-max tw-px-5 tw-justify-center ",
            children: [
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold ".concat(cs),
                    children: name
                }),
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(TitlePartial));


/***/ }),

/***/ 91963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7806);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42031);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83554);
/* harmony import */ var _components_ui_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34794);






var ReferralPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: "Giới thiệu An Thư - Landing page",
                description: "Giới thiệu An Thư - Landing page"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-w-screen tw-min-h-screen tw-h-max tw-bg-no-repeat",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-flex tw-items-center tw-justify-center tw-bg-white tw-sticky tw-top-0 tw-left-0 tw-right-0 tw-bg-cover tw-bg-top tw-bg-no-repeat tw-py-3 md:tw-py-5 tw-border-b border-color-custom-header tw-z-50",
                        style: {
                            backgroundImage: "url('/header.svg')"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                            url: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                className: "tw-h-12 md:tw-h-16 lg:tw-h-20 tw-pointer-events-none tw-cursor-pointer",
                                type: "image/svg+xml",
                                data: "/logo-has-bg.svg"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-relative tw-w-full tw-pb-70-percent md:tw-pb-35-percent",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                className: "tw-text-sm md:tw-text-lg xl:tw-text-xl tw-uppercase !tw-text-white tw-font-semibold tw-px-6 md:tw-px-10 tw-py-3 xl:tw-py-5 tw-bg-primary-main tw-rounded-5 md:tw-rounded-lg tw-z-10 tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-bottom-8 md:tw-bottom-12 lg:tw-bottom-16 xl:tw-bottom-24 2xl:tw-bottom-36",
                                url: {
                                    pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_2__/* .PagePath.AccountProfilePage */ ._.AccountProfilePage
                                },
                                children: "THAM GIA NGAY"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                className: "tw-h-full tw-w-full tw-hidden md:tw-block !tw-absolute tw-left-0 tw-top-0",
                                src: "/banner-landingpage.jpg",
                                alt: "banner"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                className: "tw-h-full tw-w-full tw-block md:tw-hidden !tw-absolute tw-left-0 tw-top-0",
                                src: "/banner-mobile.jpg",
                                alt: "banner"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-py-10 container tw-m-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "referral-landing-title tw-relative tw-flex tw-justify-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-flex tw-bg-white tw-w-max tw-items-center tw-justify-center tw-px-5 tw-z-10",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                            src: "/ico_star.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "tw-block tw-px-4 tw-w-48 lg:tw-w-max tw-text-center !tw-text-xl md:!tw-text-3xl tw-uppercase tw-text-primary-main tw-font-semibold ",
                                            children: "điều kiện chương tr\xecnh"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                            src: "/ico_star.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-mt-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-x-14",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            className: "tw-flex-1 tw-list-disc tw-text-sm md:tw-text-lg tw-text-secondary-70 tw-pl-4 md:tw-pl-10",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-7",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "tw-font-bold tw-underline",
                                                            children: "Thời gian:"
                                                        }),
                                                        " 24-25/12/2022"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-7",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "tw-font-bold tw-underline",
                                                            children: "Người tham gia:"
                                                        }),
                                                        " Người giới thiệu & người được giới thiệu"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-7",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "tw-font-bold tw-underline",
                                                            children: "Người giới thiệu:"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        " Người ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: "đ\xe3 c\xf3 t\xe0i khoản"
                                                        }),
                                                        " tr\xean ứng dụng An Thu giới thiệu đến người th\xe2n, bạn b\xe8 tải app, đăng k\xfd sử dụng v\xe0 mua h\xe0ng th\xe0nh c\xf4ng",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            className: "tw-text-primary-main",
                                                            children: "sẽ nhận được 3.00 ATD (tương đương 300,000 đ)"
                                                        }),
                                                        " v\xe0o t\xe0i khoản."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-7",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "tw-font-bold tw-underline",
                                                            children: "Người được giới thiệu:"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        "Tải app, tạo t\xe0i khoản & ho\xe0n th\xe0nh đơn h\xe0ng đầu ti\xean",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            className: "tw-text-primary-main",
                                                            children: "sẽ nhận được 12.00 ATD (tương đương 1,200,000 đ)."
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-text-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                                src: "/gift-referral.png",
                                                alt: "gift image",
                                                className: "tw-w-64 tw-h-64 md:tw-w-72 md:tw-h-72 lg:tw-w-80 lg:tw-h-80"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-py-10",
                        style: {
                            background: "linear-gradient(251.98deg, rgba(16, 102, 87, 0.09) 34.86%, rgba(16, 102, 87, 0.09) 34.86%, rgba(255, 113, 13, 0.09) 114.78%)"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "tw-relative tw-flex tw-justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        className: "!tw-text-xl md:!tw-text-3xl __title-step",
                                        cs: "!tw-w-40 tw-text-center lg:!tw-w-max",
                                        name: "c\xe1c bước tham gia"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-mt-10 md:tw-px-10",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-20",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tw-leading-7 tw-text-sm md:tw-text-lg tw-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "tw-w-6 tw-h-6 md:tw-w-8 md:tw-h-8 tw-bg-primary-main tw-text-white tw-flex tw-items-center tw-rounded-full tw-justify-center tw-mr-2 ",
                                                                    children: "1."
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "tw-flex-1 md:tw-h-14 tw-text-secondary-70",
                                                                    children: [
                                                                        "V\xe0o trang c\xe1 nh\xe2n, chọn ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                                            children: "Giới thiệu An Thư"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "tw-pt-8 md:tw-pt-10 tw-flex tw-justify-center lg:tw-justify-start lg:tw-pl-10",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                className: "tw-w-80 tw-h-60 tw-pointer-events-none tw-cursor-pointer",
                                                                type: "image/svg+xml",
                                                                data: "/ref-step-1.svg"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "tw-mt-4 lg:tw-mt-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tw-leading-7 tw-text-sm md:tw-text-lg tw-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "tw-w-6 tw-h-6 md:tw-w-8 md:tw-h-8 tw-bg-primary-main tw-text-white tw-flex tw-items-center tw-rounded-full tw-justify-center tw-mr-2",
                                                                    children: "2."
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "tw-flex-1 tw-h-14 tw-text-secondary-70",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                                            children: "Sao ch\xe9p m\xe3"
                                                                        }),
                                                                        " hoặc ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                                            children: "sao ch\xe9p link"
                                                                        }),
                                                                        " trang website giới thiệu v\xe0",
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                                            children: "gửi cho người th\xe2n, bạn b\xe8."
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "tw-pt-10 tw-flex tw-justify-center lg:tw-justify-start lg:tw-pl-10",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                className: "tw-w-80 tw-h-60 tw-pointer-events-none tw-cursor-pointer",
                                                                type: "image/svg+xml",
                                                                data: "/ref-step-2.svg"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-flex tw-justify-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                className: "md:tw-text-lg xl:tw-text-xl tw-uppercase !tw-text-white tw-font-semibold tw-mt-10 md:tw-mt-16 tw-px-10 tw-py-3 xl:tw-py-5 tw-bg-primary-main tw-rounded-5 md:tw-rounded-lg",
                                                url: {
                                                    pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_2__/* .PagePath.AccountProfilePage */ ._.AccountProfilePage
                                                },
                                                children: "Bắt đầu giới thiệu"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-py-10 container tw-m-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "referral-landing-title tw-relative tw-flex tw-justify-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-flex tw-bg-white tw-w-max tw-items-center tw-justify-center tw-px-5 tw-z-10",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                            src: "/ico_star.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "tw-block tw-px-4 tw-w-40 tw-text-center lg:tw-w-max tw-text-xl md:tw-text-3xl tw-uppercase tw-text-primary-main tw-font-semibold ",
                                            children: "C\xe1c c\xe2u hỏi li\xean quan"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                                            src: "/ico_star.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-mt-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-14",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            className: "tw-flex-1 tw-text-sm md:tw-text-lg tw-text-secondary-70 tw-pl-1 md:tw-pl-10",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "tw-font-bold",
                                                            children: "1. L\xe0m thế n\xe0o để trở th\xe0nh Người giới thiệu của AnThu?"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "tw-italic",
                                                            children: "Để trở th\xe0nh Người giới thiệu bạn chỉ cần l\xe0 người đ\xe3 c\xf3 t\xe0i khoản tại ứng dụng AnThu."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "tw-font-bold",
                                                            children: "2. L\xe0m thế n\xe0o để ho\xe0n th\xe0nh một lượt giới thiệu đến bạn b\xe8?"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "tw-italic",
                                                            children: "Hướng dẫn bạn b\xe8 tải ứng dụng sau đ\xf3 tạo t\xe0i khoản v\xe0 đăng nhập. Bạn b\xe8 của qu\xfd kh\xe1ch ho\xe0n th\xe0nh đơn h\xe0ng đầu ti\xean l\xe0 đ\xe3 ho\xe0n th\xe0nh 1 lượt giới thiệu."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "tw-font-bold",
                                                            children: "3. T\xf4i c\xf3 thể biết những t\xe0i khoản đ\xe3 giới thiệu th\xe0nh c\xf4ng ở đ\xe2u?"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "tw-italic",
                                                            children: [
                                                                "Qu\xfd kh\xe1ch c\xf3 thể xem ở phần: ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                "a. V\xe0o tab C\xe1 nh\xe2n",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                "b. Chọn Giới thiệu An Thư",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                "c. Bấm Danh s\xe1ch đ\xe3 giới thiệu"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "tw-leading-8",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "tw-font-bold",
                                                        children: "4. T\xf4i cần giới thiệu bao nhi\xeau bạn b\xe8 th\xec được nhận thưởng?"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            className: "tw-flex-1 tw-text-sm md:tw-text-lg tw-text-secondary-70 tw-pl-1 md:tw-pl-10",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "tw-leading-8",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "tw-italic",
                                                        children: "Chương tr\xecnh kh\xf4ng c\xf3 quy định số lượng Kh\xe1ch h\xe0ng được giới thiệu tối thiểu để nhận thưởng."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "tw-font-bold",
                                                            children: "5. T\xf4i nhận được điểm thưởng v\xe0o thời gian n\xe0o?"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "tw-italic",
                                                            children: "Qu\xfd kh\xe1ch sẽ nhận được điểm thưởng ngay lập tức khi người được giới thiệu ho\xe0n th\xe0nh đơn đầu ti\xean."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "tw-font-bold",
                                                            children: "6. T\xf4i sẽ được nhận thưởng qua h\xecnh thức n\xe0o?"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "tw-italic",
                                                            children: "ATD sẽ tự động được cộng v\xe0o v\xed ATD trong t\xe0i khoản tr\xean ứng dụng An Thư của qu\xfd kh\xe1ch h\xe0ng."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "tw-leading-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "tw-font-bold",
                                                            children: "7. ATD l\xe0 g\xec?"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "tw-italic",
                                                            children: "ATD l\xe0 viết tắt của An Thư Điểm, ATD được ph\xe1t h\xe0nh bởi An Thư Diamond Store. ATD d\xf9ng để thanh to\xe1n v\xe0 mua sắm trực tuyến tr\xean website anthu.vn hoặc ứng dụng Anthu. ATD kh\xf4ng đổi được th\xe0nh tiền mặt nhưng bạn c\xf3 thể chuyển tặng cho người kh\xe1c. Kh\xe1ch h\xe0ng cũng c\xf3 thể mua ATD tại website anthu.vn hoặc ứng dụng Anthu."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-py-10 lg:tw-py-16 tw-font-semibold tw-text-white tw-bg-top tw-bg-cover tw-text-center",
                        style: {
                            backgroundImage: "url(/bg-footer-landingpage.svg)"
                        },
                        children: "Copyright \xa9 2022 Blog An Thư. All rights reserved."
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ReferralPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(96604); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);